module.exports = __webpack_public_path__ + "img/205.b205e541.png";